<template>
  <div>
    <Loading :value="loading"></Loading>
    <v-layout row>
      <v-flex xs12>
        <v-card color="" class="mb-5" flat>
          <v-layout wrap>
            <v-flex md12>
              <v-alert :value="true" outline color="purple" icon="info">
                TABLEAU COMPARATIF DES PROJETS
              </v-alert>
              <br />
              <br />
              <v-layout row class="elevation-12 pt-1 mb-3">
                <v-flex xs12 class="text-xs-center">
                  <h3>Critères de recherche</h3>
                  <v-divider class="mb-2"></v-divider>
                  <el-form
                    :inline="true"
                    :model="formTri"
                    id="formTri"
                    class="demo-form-inline"
                  >
                    <el-form-item label="Projet" width="400px">
                      <el-select
                        class="custom-select"
                        v-on:change="onchangeInfo(selectProjet)"
                        filterable
                        multiple
                        clearable
                        collapse-tags
                        v-model="selectProjet"
                        placeholder="Projet"
                      >
                        <el-option
                          v-for="item in listProjetDepense"
                          :key="item.idProjet"
                          :label="item.libelleProjet"
                          :value="item.idProjet"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="Numéro de compte">
                      <el-select
                        class="custom-select"
                        clearable
                        v-model="selectPlan"
                        v-on:change="onchangeCompte(selectPlan)"
                        filterable
                        multiple
                        placeholder="Numéro de compte"
                      >
                        <el-option
                          v-for="item in listPlanComptable"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="Période">
                      <el-date-picker
                        style="width: 100%"
                        v-model="selectAnnee"
                        format="dd-MM-yyyy"
                        value-format="yyyy-MM-dd"
                        type="datetimerange"
                        range-separator="à"
                        start-placeholder="Début date"
                        end-placeholder="Fin date"
                      ></el-date-picker>
                    </el-form-item>

                    <el-form-item label="">
                      <v-tooltip bottom>
                        <v-btn
                          @click="loadChantierSearch()"
                          slot="activator"
                          class="white--text"
                          color="blue"
                          fab
                          small
                        >
                          <v-icon>search</v-icon>
                        </v-btn>
                        Effectuer une recherche
                      </v-tooltip>
                    </el-form-item>
                  </el-form>
                </v-flex>
              </v-layout>

              <v-flex xs12 class="text-xs-right">
                <v-tooltip top>
                  <v-btn
                    v-if="true"
                    slot="activator"
                    color="green"
                    @click.stop="newImporter()"
                    dark
                  >
                    Importer
                    <v-icon right>file_download</v-icon> </v-btn
                  >Importer fichier excel
                </v-tooltip>

                <v-tooltip top>
                  <v-btn
                    v-if="true"
                    slot="activator"
                    color="orange"
                    @click.stop="generateFileExcel()"
                    dark
                  >
                    Générer
                    <v-icon right>file_upload</v-icon> </v-btn
                  >Générer un modèle
                </v-tooltip>
              </v-flex>

              <br />
              <br />
              <v-layout row class="mb-2">
                <v-chip
                  style="border-radius: 16px;"
                  text-color="white"
                  v-if="showRecherche"
                  label
                  color="warning"
                >
                  RESULATS DE LA RECHERCHE
                </v-chip>
                <div v-if="showRecherche && projetsSelectionnes.length > 0">
                  <h3>Projets sélectionnés :</h3>
                  <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                    <v-chip
                      v-for="(projet, index) in projetsSelectionnes"
                      :key="index"
                      style="border-radius: 16px;"
                      text-color="white"
                      label
                      color="success"
                    >
                      {{ projet }}
                    </v-chip>
                  </div>
                </div>
                <div v-if="showRecherche && plansSelectionnes.length > 0">
                  <h3>Plans comptables sélectionnés :</h3>
                  <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                    <v-chip
                      v-for="(projet, index) in plansSelectionnes"
                      :key="index"
                      style="border-radius: 16px;"
                      text-color="white"
                      label
                      color="info"
                    >
                      {{ projet }}
                    </v-chip>
                  </div>
                </div>
                <v-chip
                  style="border-radius: 16px;"
                  text-color="white"
                  v-if="showRecherche && selectAnnee && selectAnnee != ''"
                  label
                  color="primary"
                  >PÉRIODE DU {{ selectAnnee ? selectAnnee[0] : "" }} au
                  {{ selectAnnee ? selectAnnee[1] : "" }}</v-chip
                >
              </v-layout>
              <v-layout row class="mb-2" v-if="!hideInterface">
                <v-flex sm3 class="mr-1">
                  <v-card
                    color="teal lighten-1"
                    class="white--text elevation-5"
                  >
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>NOMBRE TOTAL DE PROJETS</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                totalInfo.nombreTotalProjets
                              )
                            }}
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>

                <v-flex sm3 class="mr-1">
                  <v-card
                    color="indigo lighten-1"
                    class="white--text elevation-5"
                  >
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>MONTANT TOTAL DES MARCHÉS</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                totalInfo.totalMontantMarche
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>

                <v-flex sm3 class="mr-1">
                  <v-card
                    color="brown lighten-1"
                    class="white--text elevation-5"
                  >
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>BUDGET TOTAL</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                totalInfo.totalBudget
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>

                <v-flex sm3 class="mr-1">
                  <v-card color="red darken-2" class="white--text elevation-5">
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>MONTANT TOTAL DÉCAISSÉ</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                totalInfo.totalMontantDepenses
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout row class="mb-2" v-if="!hideInterface">
                <v-flex sm3 class="mr-1">
                  <v-card
                    color="green darken-2"
                    class="white--text elevation-5"
                  >
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>CHIFFRE D'AFFAIRES ENCAISSÉ</div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                totalInfo.totalMontantEncaisse
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>

                <!-- <v-flex sm3 class="mr-1">
                    <v-card color="orange darken-2"  class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                            <v-layout row>
                                <v-flex xs12 style=" text-align: center;">
                                    <div>MONTANT TOTAL CHARGES DIRECTES</div>
                                    <div class="display-1">
                                      {{ new Intl.NumberFormat().format(totalInfo.totalDirectCharges)}} XOF                                   
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                
                  </v-flex>

                  <v-flex sm3 class="mr-1">
                    <v-card color="blue-grey darken-2"  class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                            <v-layout row>
                                <v-flex xs12 style=" text-align: center;">
                                    <div>MONTANT TOTAL DES CHARGES INDIRECTES</div>
                                    <div class="display-1">
                                      {{ new Intl.NumberFormat().format(totalInfo.totalIndirectCharges)}} XOF                                   
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                
                  </v-flex> -->

                <v-flex sm3 class="mr-1">
                  <v-card
                    color="green darken-2"
                    class="white--text elevation-5"
                  >
                    <v-container fluid grid-list-lg>
                      <v-layout row>
                        <v-flex xs12 style=" text-align: center;">
                          <div>
                            MARGE TOTALE (MONTANT MARCHÉ - MONTANT DÉCAISSÉ)
                          </div>
                          <div class="display-1">
                            {{
                              new Intl.NumberFormat().format(
                                totalInfo.totalMarges
                              )
                            }}
                            XOF
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
              <br />
              <br />

              <!-- STAT DES INDICATEURS CLES PAR PROJETS -->
              <v-layout row class="mb-2" v-if="!hideInterface">
                <div ref="bar_chart" class="chart"></div>
              </v-layout>
              <br />
              <br />
              <!-- COURBE DEVOLUTION DES MARGES  -->
              <v-layout row class="mb-2" v-if="!hideInterface">
                <div ref="chart" style="width: 100%; height: 400px;"></div>
              </v-layout>

              <br />
              <br />
              <!-- COURBE DEVOLUTION DES TRANSACTION DEBIT ET CREDIT  -->
              <v-layout row class="mb-2">
                <!-- <div id="chart-container" style="width: 100%; height: 500px;"></div> -->
                <div ref="trans" style="width: 100%; height: 400px;"></div>
              </v-layout>

              <br />
              <br />
              <v-card color="" class="mb-5">
                <v-card-text>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      class="text-xs-right"
                      v-if="listTravauxResult.length > 0"
                    >
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          color="orange"
                          @click.stop="dialogueImprimer = true"
                          dark
                        >
                          Exporter en Pdf
                          <v-icon right>print</v-icon> </v-btn
                        >Pdf
                      </v-tooltip>
                    </v-flex>

                    <data-tables
                      :data="listTravauxResult"
                      style="width:100%;"
                      :summary-method="calculateSummaries"
                      show-summary
                    >
                      <!--expand liste classe comptable-->
                      <el-table-column type="expand">
                        <template slot-scope="props">
                          <el-row class="elevation-3 pl-4 pr-4 pt-2">
                            <el-col :span="24">
                              <div class="grid-content bg-purple mb-2">
                                <div>
                                  <v-chip
                                    dark
                                    label
                                    color="purple"
                                    text-color="white"
                                  >
                                    <v-icon left>label</v-icon>
                                    <span>LISTE PAR NUMERO DE COMPTE </span>
                                  </v-chip>

                                  <data-tables
                                    ref="multipleTable"
                                    :data="props.row.marche"
                                    align="center"
                                    :summary-method="calculateSummaries"
                                    show-summary
                                    height="550"
                                    style="width:100%"
                                  >
                                    <!--expand liste transaction-->
                                    <el-table-column type="expand">
                                      <template slot-scope="props">
                                        <el-row
                                          class="elevation-3 pl-4 pr-4 pt-2"
                                        >
                                          <el-col :span="24">
                                            <div
                                              class="grid-content bg-purple mb-2"
                                            >
                                              <div>
                                                <v-chip
                                                  dark
                                                  label
                                                  color="purple"
                                                  text-color="white"
                                                >
                                                  <v-icon left>label</v-icon>
                                                  <span
                                                    >LISTE DES
                                                    TRANSACTIONS</span
                                                  >
                                                </v-chip>

                                                <data-tables
                                                  ref="multipleTable"
                                                  :data="props.row.depenses"
                                                  align="center"
                                                  :summary-method="
                                                    calculateSummaries
                                                  "
                                                  show-summary
                                                  height="550"
                                                  style="width:100%"
                                                >
                                                  <el-table-column
                                                    prop="date"
                                                    label="Date"
                                                    align="center"
                                                    width="300"
                                                  >
                                                    <template
                                                      slot-scope="scope"
                                                    >
                                                      <v-chip
                                                        outline
                                                        label
                                                        text-color="primary"
                                                        color="green"
                                                        >{{
                                                          scope.row.date
                                                        }}</v-chip
                                                      >
                                                    </template>
                                                  </el-table-column>

                                                  <el-table-column
                                                    prop="libelleDepense"
                                                    label="Libellé de l'opération"
                                                    align="center"
                                                    width="300"
                                                  >
                                                    <template
                                                      slot-scope="scope"
                                                    >
                                                      <v-chip
                                                        outline
                                                        label
                                                        text-color="primary"
                                                        color="primary"
                                                        >{{
                                                          scope.row
                                                            .libelleDepense
                                                        }}</v-chip
                                                      >
                                                    </template>
                                                  </el-table-column>

                                                  <el-table-column
                                                    label="MOUVEMENTS"
                                                    align="center"
                                                  >
                                                    <el-table-column
                                                      prop="montantD"
                                                      label="DÉBITS"
                                                    >
                                                      <template
                                                        slot-scope="scope"
                                                      >
                                                        <v-chip
                                                          text-color="white"
                                                          label
                                                          color="red"
                                                          >{{
                                                            new Intl.NumberFormat().format(
                                                              scope.row.montantD
                                                            )
                                                          }}
                                                          XOF
                                                        </v-chip>
                                                      </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                      prop="montantC"
                                                      label="CRÉDITS"
                                                    >
                                                      <template
                                                        slot-scope="scope"
                                                      >
                                                        <v-chip
                                                          text-color="white"
                                                          label
                                                          color="green"
                                                          >{{
                                                            new Intl.NumberFormat().format(
                                                              scope.row.montantC
                                                            )
                                                          }}
                                                          XOF
                                                        </v-chip>
                                                      </template>
                                                    </el-table-column>
                                                  </el-table-column>

                                                  <el-table-column
                                                    label="SOLDES"
                                                    align="center"
                                                  >
                                                    <el-table-column
                                                      prop="soldeD"
                                                      label="DÉBITEURS"
                                                    >
                                                      <template
                                                        slot-scope="scope"
                                                      >
                                                        <v-chip
                                                          text-color="white"
                                                          label
                                                          color="red"
                                                          >{{
                                                            new Intl.NumberFormat().format(
                                                              scope.row.soldeD
                                                            )
                                                          }}
                                                          XOF
                                                        </v-chip>
                                                      </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                      prop="soldeC"
                                                      label="CRÉDITEURS"
                                                    >
                                                      <template
                                                        slot-scope="scope"
                                                      >
                                                        <v-chip
                                                          text-color="white"
                                                          label
                                                          color="green"
                                                          >{{
                                                            new Intl.NumberFormat().format(
                                                              scope.row.soldeC
                                                            )
                                                          }}
                                                          XOF
                                                        </v-chip>
                                                      </template>
                                                    </el-table-column>
                                                  </el-table-column>
                                                </data-tables>
                                              </div>
                                            </div>
                                          </el-col>
                                        </el-row>
                                      </template>
                                    </el-table-column>
                                    <!--expand-->

                                    <el-table-column
                                      prop="libelleCompte"
                                      label="NUMÉRO DE COMPTE"
                                      align="center"
                                      width="300"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          outline
                                          label
                                          text-color="primary"
                                          color="primary"
                                          >{{ scope.row.code }}
                                          {{ scope.row.libelleCompte }}</v-chip
                                        >
                                      </template>
                                    </el-table-column>

                                    <el-table-column
                                      label="MOUVEMENTS"
                                      align="center"
                                    >
                                      <el-table-column
                                        prop="totalMontantD"
                                        label="DÉBIT"
                                      >
                                        <template slot-scope="scope">
                                          <v-chip
                                            text-color="white"
                                            label
                                            color="red"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                scope.row.totalMontantD
                                              )
                                            }}
                                            XOF
                                          </v-chip>
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        prop="totalMontantC"
                                        label="CRÉDIT"
                                      >
                                        <template slot-scope="scope">
                                          <v-chip
                                            text-color="white"
                                            label
                                            color="green"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                scope.row.totalMontantC
                                              )
                                            }}
                                            XOF
                                          </v-chip>
                                        </template>
                                      </el-table-column>
                                    </el-table-column>

                                    <el-table-column
                                      label="SOLDES"
                                      align="center"
                                    >
                                      <el-table-column
                                        prop="totalSoldeD"
                                        label="TOTAL DÉBITEURS"
                                      >
                                        <template slot-scope="scope">
                                          <v-chip
                                            text-color="white"
                                            label
                                            color="red"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                scope.row.totalSoldeD
                                              )
                                            }}
                                            XOF</v-chip
                                          >
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        prop="totalSoldeC"
                                        label="TOTAL CRÉDITEURS"
                                      >
                                        <template slot-scope="scope">
                                          <v-chip
                                            text-color="white"
                                            label
                                            color="green"
                                            >{{
                                              new Intl.NumberFormat().format(
                                                scope.row.totalSoldeC
                                              )
                                            }}
                                            XOF</v-chip
                                          >
                                        </template>
                                      </el-table-column>
                                    </el-table-column>
                                  </data-tables>
                                </div>
                              </div>
                            </el-col>
                          </el-row>
                        </template>
                      </el-table-column>
                      <!--expand-->

                      <el-table-column
                        prop="libelleProjet"
                        label="LIBELLÉ PROJET"
                        align="center"
                        width="300"
                      >
                        <template slot-scope="scope">
                          <v-chip
                            outline
                            label
                            text-color="primary"
                            color="primary"
                            >{{ scope.row.libelleProjet }}</v-chip
                          >
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-if="!hideInterface"
                        label="ÉVOLUTION PHYSIQUE"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <v-progress-circular
                            :size="80"
                            :width="15"
                            :rotate="360"
                            :value="scope.row.evolution"
                            color="orange"
                            >{{ scope.row.evolution }} %</v-progress-circular
                          >
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-if="!hideInterface"
                        label="MONTANT DU MARCHÉ "
                        align="center"
                      >
                        <template slot-scope="scope">
                          <v-chip
                            outline
                            label
                            text-color="primary"
                            color="green"
                            >{{
                              new Intl.NumberFormat().format(
                                scope.row.montantMarche
                              )
                            }}
                            XOF
                          </v-chip>
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-if="!hideInterface"
                        label="BUDGET ESTIMATIF "
                        align="center"
                      >
                        <template slot-scope="scope">
                          <v-chip
                            outline
                            label
                            text-color="primary"
                            color="green"
                            >{{
                              new Intl.NumberFormat().format(scope.row.budget)
                            }}
                            XOF
                          </v-chip>
                        </template>
                      </el-table-column>

                      <el-table-column label="MOUVEMENTS" align="center">
                        <el-table-column prop="montantD" label="DÉBIT">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="red"
                              >{{
                                new Intl.NumberFormat().format(
                                  scope.row.montantD
                                )
                              }}
                              XOF
                            </v-chip>
                          </template>
                        </el-table-column>

                        <el-table-column prop="montantC" label="CRÉDIT">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="green"
                              >{{
                                new Intl.NumberFormat().format(
                                  scope.row.montantC
                                )
                              }}
                              XOF
                            </v-chip>
                          </template>
                        </el-table-column>
                      </el-table-column>

                      <el-table-column label="SOLDES" align="center">
                        <el-table-column prop="soldeDebit" label="DÉBITEURS">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="red"
                              >{{
                                new Intl.NumberFormat().format(
                                  scope.row.soldeDebit
                                )
                              }}
                              XOF</v-chip
                            >
                          </template>
                        </el-table-column>

                        <el-table-column prop="soldeCredit" label="CRÉDITEURS">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="green"
                              >{{
                                new Intl.NumberFormat().format(
                                  scope.row.soldeCredit
                                )
                              }}
                              XOF
                            </v-chip>
                          </template>
                        </el-table-column>
                      </el-table-column>

                      <el-table-column
                        label="MARGE"
                        v-if="!hideInterface"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <v-chip
                            outline
                            label
                            text-color="NumberFormat"
                            color="green"
                            >{{
                              new Intl.NumberFormat().format(scope.row.marge)
                            }}
                            XOF
                          </v-chip>
                        </template>
                      </el-table-column>
                    </data-tables>
                    <br />
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Modal -->
    <v-dialog v-model="dialogShowGraph" max-width="500px">
      <v-card>
        <v-card-title class="headline">Détails du projet</v-card-title>
        <v-card-text>
          <!-- Contenu du modal (par exemple, des détails supplémentaires) -->
          <p>Voici plus de détails sur les projets.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="dialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL IMPRESSION BDE COMMANDE-->
    <v-dialog
      v-model="dialogueImprimer"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
      <v-btn icon @click.native="dialogueImprimer = false" dark class="blue"
        ><v-icon>close</v-icon>
      </v-btn>
    </v-dialog>

    <!-- MODAL AJOUT DE DONNEE -->
    <v-dialog
      v-model="dialogNewImporter"
      max-width="40%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="info darken-4">
          <v-toolbar-title>
            <span>Importer des données</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogNewImporter = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text text-xs-center>
          <h4 align="center" style="color: red;">
            Nb : Veuillez vous assurer d'avoir respecté les critères du fichier
            avant l'importation.
          </h4>
          <h4 align="center" style="color: red;">
            -> Formatez la colonne de date sous le format "Date courte"
            (JJ/MM/AAAA).
          </h4>
          <h4 align="center" style="color: red;">
            -> Formatez toutes les colonnes contenant des valeurs numériques au
            format "123 Nombre".
          </h4>
          <p align="center">
            <v-form
              v-model="valid"
              ref="formStock"
              lazy-validation
              id="formStock"
            >
              <v-container fluid grid-list-md>
                <v-layout row>
                  <v-flex md6>
                    <div class="block">
                      <span class="demonstration">Sélectionnez le projet</span>
                      <el-select
                        filterable
                        v-on:change="onchangeInfo(projetS)"
                        clearable
                        v-model="projetS"
                        placeholder="Sélectionnez un Projet"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listeProjet"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md6>
                    <div class="block">
                      <span class="demonstration"
                        >Sélectionnez un fichier Excel</span
                      >
                      <v-tooltip mt-2 top>
                        <input
                          name="fileInputExcel"
                          type="file"
                          style="display:none"
                          ref="fileInputExcel"
                          accept=".xls,.xlsx"
                          v-on:change="onFileExcelPicked"
                        />
                        <v-btn
                          slot="activator"
                          color="green"
                          @click.stop="$refs.fileInputExcel.click()"
                          dark
                        >
                          Sélectionnez un fichier Excel
                          <v-icon right>file_download</v-icon>
                        </v-btn>
                      </v-tooltip>
                    </div>
                  </v-flex>
                </v-layout>
                <div v-if="selectedFileName.length > 0" class="mt-2">
                  <v-alert
                    class="elevation-1 subheading mb-1"
                    color="warning"
                    :value="true"
                    outline
                  >
                    Fichier sélectionné :
                    <strong>{{ selectedFileName }}</strong>
                  </v-alert>
                </div>
                <br />
                <v-flex xs12 class="text-xs-right">
                  <v-btn @click="dialogNewImporter = false" color="orange" dark>
                    Annuler
                    <v-icon right>close</v-icon>
                  </v-btn>
                  <v-btn
                    icons
                    color="blue"
                    @click="submitImport()"
                    :disabled="!valid"
                    dark
                  >
                    Enregistrer
                    <v-icon right>save</v-icon>
                  </v-btn>
                </v-flex>
              </v-container>
            </v-form>
          </p>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <LoadDepenseProduitExcel
      @close="closeFormTypeProduit()"
      :show="showModalLoadData"
      :projet="listeInfoProjet"
      :listeTypeTravaux="listDataDepenses"
      :listTotals = "listTotals"
    ></LoadDepenseProduitExcel>

    <LoadShowGraph
      @close="closeFormShowGraph()"
      :show="showModalgraphData"
      :listeData="listeData"
      :typeGraph="typeGraph"
    ></LoadShowGraph>
  </div>
</template>

<style>
.card {
  background-color: #fff;
  border-radius: 10px;
  border: none;
  position: relative;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 30px;
  box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1),
    0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1),
    0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12),
    0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);
}
#appercu {
  position: absolute;
  top: 15px;
  left: 40px;
  display: none;
  width: 40px;
  height: 20px;
}
.card h4:hover {
  display: block;
}

#price {
  border: none;
  position: relative;
  margin: 0 auto;
  text-align: center;
}

.l-bg-cherry {
  background: linear-gradient(to right, #493240, #f09) !important;
  color: #fff;
}

.l-bg-blue-dark {
  background: linear-gradient(to right, #373b44, #4286f4) !important;
  color: #fff;
}

.l-bg-green-dark {
  background: linear-gradient(to right, #0a504a, #38ef7d) !important;
  color: #fff;
}

.l-bg-red-dark {
  background: linear-gradient(to right, #c71111, #ffba56) !important;
  color: #fff;
}
.l-bg-orange-dark {
  background: linear-gradient(to right, #a86008, #ffba56) !important;
  color: #fff;
}

.card .card-statistic-3 .card-icon-large .fas,
.card .card-statistic-3 .card-icon-large .far,
.card .card-statistic-3 .card-icon-large .fab,
.card .card-statistic-3 .card-icon-large .fal {
  font-size: 110px;
}

.card .card-statistic-3 .card-icon {
  text-align: center;
  line-height: 50px;
  margin-left: 15px;
  color: #000;
  position: absolute;
  right: -5px;
  top: 20px;
  opacity: 0.1;
}

.l-bg-cyan {
  background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
  color: #fff;
}

.l-bg-green {
  background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%) !important;
  color: #fff;
}

.l-bg-orange {
  background: linear-gradient(to right, #f9900e, #ffba56) !important;
  color: #fff;
}

.l-bg-red {
  background: linear-gradient(to right, #c71111, #ffba56) !important;
  color: #fff;
}

.l-bg-cyan {
  background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
  color: #fff;
}
.dashboard-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.summary-cards {
  display: flex;
  gap: 50px;
}

.summary-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.card-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  font-size: 24px;
}

.card-details {
  margin-left: 15px;
}

.charts-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.chart {
  width: 100%;
  height: 300px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.custom-select .el-select__tags {
  max-width: 100%; /* Limite la largeur au conteneur parent */
  overflow: hidden; /* Cache le débordement */
  text-overflow: ellipsis; /* Ajoute "..." si le texte déborde */
  white-space: nowrap; /* Empêche le retour à la ligne */
}

.custom-select .el-select__tags:hover {
  overflow-x: auto; /* Active le défilement horizontal au survol */
}

#chart-container {
  width: 100%;
  height: 500px;
}
</style>

<script>
// var echarts = require('echarts/lib/echarts')
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import * as echarts from "echarts"; // Utilise cette méthode pour importer echarts
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";

import Loading from "@/components/Loading";
import LoadDepenseProduitExcel from "@/components/divers/LoadDepenseProduitExcel.vue";
import LoadShowGraph from "@/components/projet/LoadShowGraph.vue";

export default {
  components: {
    Loading,
    LoadDepenseProduitExcel,
    LoadShowGraph,
    "v-chart": ECharts
  },
  name: "DetailBudgetProjet",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      summaries: [],
      loading: false,
      dialogShowGraph: false,
      dialogNewImporter: false,
      dialogDetail: false,
      showButonExcel: false,
      dialogueImprimer: false,
      listPlanComptable: [],
      listeRecherche: [],
      listeRapport: [],
      listeChantier: [],
      listeInfoProjet: [],
      listeData: [],
      listTravaux: [],
      listeTypeCharge: [
        { text: "DIRECT", value: "DIRECT" },
        { text: "INDIRECTE", value: "INDIRECTE" }
      ],
      selectTaches: "",
      listTravauxResult: [],
      listProjetDepense: [],
      totalInfo: [],
      selectTravaux: "",
      typeGraph: "",
      listChargeResult: [],
      mntTotalChargeI: 0,
      mntTotalChargeD: 0,
      mntTotalChargeDE: 0,
      mntTotalChargeMA: 0,
      mntTotalDepense: 0,
      listeBudget: [],
      bilanMensuel: [],
      listTaches: [],
      listDataDepenses: [],
      listTotals: [],
      infoProjet: null,
      selectAnnee: "",
      bilanTravaux: [],
      listeDetail: [],
      selectTypeCharge: null,
      showModalLoadData: false,
      showModalgraphData: false,
      helpDemande: [
        {
          num: "1",
          text: "Somme de toutes les commandes éffectuées"
        },
        {
          num: "2",
          text: "Somme de toutes les demandes de fond éffectuées"
        },
        {
          num: "3",
          text:
            "Somme de toutes les dépenses indiqué dans le rapport journalier"
        }
      ],
      helpDemandeN: [
        {
          num: "1",
          text: "Somme de toutes les commandes éffectuées dans les travaux"
        },
        {
          num: "2",
          text:
            "Somme de toutes les demandes de fond éffectuées dans les travaux"
        },
        {
          num: "3",
          text:
            "Somme de toutes les dépenses indiqué dans le rapport journalier dans les travaux"
        }
      ],

      //  new data
      selectProjet: [],
      projetS: null,
      selectChantier: [],
      selectPlan: [],
      libelleChantier: "",
      //critere de recherche
      formTri: { periode: "" },
      fileExcel: [],
      hideInterface: false,
      showRecherche: false,

      projetsSelectionnes: [],
      plansSelectionnes: [],
      listeProjet: [], // Remplir avec vos données de projet
      selectedFileName: "", // Nom du fichier sélectionné
      fichierSelect: null, // Fichier sélectionné
      fileExcel: [], // Liste des fichiers chargés

      compte: "0",
      dialogConfirm: false,
      disabledBtnPop: false,
      totalMntPropose: 0,
      totalMntValide: 0
    };
  },

  computed: {},
  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDetail = newValue;
      if (newValue == true) {
        this.listeBudget = this.detailProjet.budgets;
        let _this = this;
        this.totalMntPropose = 0;
        this.totalMntValide = 0;
        this.totalMntMarche = 0;
        this.listeBudget.forEach(item => {
          this.totalMntPropose += item.mntTotalBudgetPropose;
          this.totalMntValide += item.mntTotalBudgetValide;
        });
        this.loadBilan(this.detailProjet.idProj);
      }
    }
  },

  methods: {
    handleTabClick(tab) {
      switch (tab) {
        case "0":
          break;
        case "1":
          break;

        default:
          break;
      }
    },
    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
    statistique(dataStaBuge, dataStatDepen) {
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "Statistique des dépenses"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["TOTAL MONTANT PLANIFIÉ ", "TOTAL MONTANT HT ENGAGÉ"]
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "10%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "Janvier",
            "Fevrier",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Aout",
            "Septembre",
            "Octobre",
            "Novembre",
            "Decembre"
          ]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "TOTAL MONTANT HT PLANIFIE",
            type: "line",
            stack: "Total",
            data: []
          },
          {
            name: "TOTAL MONTANT HT ENGAGE",
            type: "line",
            stack: "Total",
            data: []
          }
        ]
      };

      let tabNb = option.xAxis.data.length;
      for (let i = 0; i < tabNb; i++) {
        for (let dataCBud in dataStaBuge) {
          let mois = option.xAxis.data;
          if (mois[i] === dataStaBuge[dataCBud]["mois"]) {
            option.series[0].data.push({
              value: dataStaBuge[dataCBud]["montant"],
              name: "TOTAL MONTANT HT PLANIFIE"
            });
          } else {
            option.series[0].data.push({
              value: 0,
              name: "TOTAL MONTANT HT PLANIFIE"
            });
          }
        }
      }
      for (let i = 0; i < tabNb; i++) {
        for (let dataCBdep in dataStatDepen) {
          let mois = option.xAxis.data;
          if (mois[i] === dataStatDepen[dataCBdep]["mois"]) {
            option.series[1].data.push({
              value: dataStatDepen[dataCBdep]["montant"],
              name: "TOTAL MONTANT HT ENGAGE"
            });
          } else {
            option.series[1].data.push({
              value: 0,
              name: "TOTAL MONTANT HT ENGAGE"
            });
          }
        }
      }

      option && myChart.setOption(option);

      // DIGRAMME CIRCULAIRE
      let optionComd = {
        title: {
          text: "Statistique des dépenses",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["PLANIFIE", "ENGAGEÉ"]
        },
        series: [
          {
            name: "DEPENSE(S)",
            type: "pie",
            radius: "75%",
            center: ["50%", "60%"],
            color: ["#ff6f43", "#26a59a"],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };

      let dataCommandeFour = [this.mntTotalChargeDE, this.mntTotalChargeMA];
      let libelle = ["Dépensé", "budget"];
      for (let dataCom in dataCommandeFour) {
        optionComd.series[0].data.push({
          value: dataCommandeFour[dataCom],
          name: libelle[dataCom]
        });
      }

      let chartDempense = echarts.init(
        document.getElementById("chartDempense")
      );
      chartDempense.setOption(optionComd);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSumm(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    closeDialog() {
      this.$emit("close");
    },
    calculateSummaries({ columns, data }) {
      const sums = [];
      console.log("columns", columns);
      console.log("data", data);

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map(item => Number(item[column.property]) || 0);
        sums[index] = values.reduce((prev, curr) => prev + curr, 0);
      });
      return sums.map(sum =>
        typeof sum === "number"
          ? new Intl.NumberFormat().format(sum) + " XOF"
          : sum
      );
    },
    handleChange(newValue, oldValue) {},
    closeFormTypeProduit() {
      this.showModalLoadData = false;
      this.loadData()
    },
    closeFormShowGraph() {
      this.showModalgraphData = false;
    },
    loadBilan(idProjet) {
      this.loading = true;
      let url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.bilanMensuel = response.body.mensuel;
          this.bilanTravaux = response.body.bilanTravaux.travaux;
          this.listeDetail = response.body.detailCompte;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement du bilan"
          );
        }
      );
    },
    loadProjet() {
      let url = this.domaine + "projet/indicateur/projet";

      this.loading = true;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProjet = response.body.projet;
          // this.listeRapport = response.body.rapport;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des projets"
          );
        }
      );
    },
    loadPlanComptable() {
      let url = this.domaine + "planComptable/all/planComptable/index";
      this.loading = true;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listPlanComptable = response.body.liste;
          // this.listeRapport = response.body.rapport;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des projets"
          );
        }
      );
    },
    loadData() {
      let url = "";
      this.loading = true;
      url = this.domaine + "projet/liste/info/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.loading = false;
          this.listTravauxResult = response.body.projets;
          this.listProjetDepense = response.body.projets;
          this.totalInfo = response.body.totals;
          this.listeData = response.body;
          this.initBarChart(response.body.barChartData); // INDICATEURS CLES PAR PROJETS
          this.initChart(response.body.barChartData); // pour COURBE DEVOLUTION DES MARGES
          this.initLineChart(response.body.stackedLinData); //INDICATEURS CLES POUR TRANSACTKON
        }
      });
    },
    loadTravaux() {
      this.listTravaux = [];
      if (this.selectChantier != "" && this.selectChantier != null) {
        this.loading = true;

        let url =
          this.domaine +
          "projet/" +
          this.selectChantier +
          "/index/chantier/travaux";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listeTravaux = response.body.travaux;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTaches() {
      this.listTravaux = [];
      if (this.selectTravaux != "" && this.selectTravaux != null) {
        this.loading = true;

        let url =
          this.domaine +
          "projet/travaux_tache/" +
          this.selectTravaux +
          "/index/tache";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTaches = response.body.tache;
            this.loading = false;
          }
        });
      }
    },
    onchangeChantier(chantierS) {
      this.listeChantier.find(item => {
        if (item.id == chantierS) {
          this.listeTravaux = item.travauxId;
        }
      });
    },
    onChangeTravaux(travaux) {
      this.listeTravaux.find(item => {
        if (item.idChantier == travaux) {
          this.listTaches = item.travauxId;
        }
      });
    },
    getSelectedProjetsLabels(row) {
      // Convertir this.selectProjet en tableau s'il ne l'est pas déjà
      const selectedIds = Array.isArray(row) ? row : [row];

      // Filtrer les projets sélectionnés et récupérer leurs informations
      const selectedProjets = this.listeProjet.filter(projet =>
        selectedIds.includes(projet.id)
      );

      // Créer un objet avec les informations des projets sélectionnés
      return selectedProjets.map(projet => ({
        id: projet.id,
        libelle: projet.libelle
      }));
    },
    getSelectedPlansLabels() {
      // Convertir this.selectPlan en tableau s'il ne l'est pas déjà
      const selectedIds = Array.isArray(this.selectPlan)
        ? this.selectPlan
        : [this.selectPlan];

      // Filtrer les plans comptables sélectionnés et récupérer leurs informations
      const selectedPlans = this.listPlanComptable.filter(plan =>
        selectedIds.includes(plan.id)
      );

      // Créer un objet avec les informations des plans sélectionnés
      return selectedPlans.map(plan => ({
        id: plan.id,
        libelle: plan.libelle,
        code: plan.code
        // Ajoutez d'autres propriétés si nécessaire
      }));
    },
    loadChantierSearch() {
      this.loading = true;

      this.listTravauxResult = [];
      this.listChantierResult = [];
      this.hideInterface = false;

      let data = new FormData();
      data.append("listProjet", this.selectProjet);
      data.append("charge", this.selectTypeCharge);
      data.append("compte", this.selectPlan);
      data.append("annee", this.selectAnnee);

      const projetsSelectionnes = [];
      this.selectProjet.forEach(id => {
        const projet = this.listeProjet.find(item => item.id === id);
        if (projet) {
          projetsSelectionnes.push(projet.libelle);
        }
      });

      // Récupérer les libellés des plans comptables sélectionnés
      const plansSelectionnes = [];
      this.selectPlan.forEach(id => {
        const plan = this.listPlanComptable.find(item => item.id === id);
        if (plan) {
          plansSelectionnes.push(plan.libelle);
        }
      });
      this.projetsSelectionnes = projetsSelectionnes;
      this.plansSelectionnes = plansSelectionnes;

      console.log("projetsSelectionnes", this.projetsSelectionnes);
      let url = this.domaine + "projet/index/recherche/info";
      this.$http.post(url, data).then(response => {
        this.loading = false;
        if (response.body) {
          this.showRecherche = true;
          this.$notify({
            title: "RESULTAT",
            message:
              response.body.projets.length > 0
                ? `La recherche a retourné ${
                    response.body.projets.length
                  } résultat(s).`
                : "Aucun résultat trouvé.",
            type: response.body.projets.length > 0 ? "success" : "warning",
            position: "top-center"
          });
          console.log("response", response);
          if (this.selectPlan.length > 0) {
            this.hideInterface = true;
          }
          this.loading = false;
          this.listTravauxResult = response.body.projets;
          this.totalInfo = response.body.totals;
          this.listeData = response.body;
          this.initBarChart(response.body.barChartData); // INDICATEURS CLES PAR PROJETS
          this.initChart(response.body.barChartData); // pour COURBE DEVOLUTION DES MARGES
          this.initLineChart(response.body.stackedLinData); //INDICATEURS CLES POUR TRANSACTKON
        }
      });
    },
    onFileExcelPicked(event) {
      this.fileExcel.splice(0, 1);
      const files = event.target.files;
      if (!files.length) return;

      let filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez sélectionner un fichier Excel valide.");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieure à 1024 ko.");
        return;
      }

      this.selectedFileName = filename; // Mettre à jour le nom du fichier sélectionné
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);
      this.fichierSelect = files[0];
    },
    submitImport() {
      console.log("this.projetS", this.projetS);
      if (this.projetS === null || this.projetS === "") {
        this.$message.error("Veuillez sélectionner le projet.");
        return;
      }
      this.loading = true;
      let url = this.domaine + "projet/load/depense/excel";
      let data = new FormData();
      data.append("fichierExcel", this.fichierSelect);

      this.$http.post(url, data).then(
        resp => {
          this.loading = false;
          this.$notify({
            title: "Chargement liste des données du fichier",
            message: "Chargement effectué",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          this.listDataDepenses = resp.body.liste;
          this.listTotals = resp.body.totals
          this.showModalLoadData = true;
          this.dialogNewImporter = false;
          this.loadPlanComptable();
        },
        () => {
          this.loading = false;
          this.$message.error("Erreur lors de l'importation du fichier");
        }
      );
    },
    generateFileExcel() {
      let url = this.domaine + "projet/generer/modele/depense/projet";
      window.open(url);
    },
    newImporter() {
      this.dialogNewImporter = true;
      this.selectedFileName = "";
      this.projetS = null;
    },

    onchangeInfo(projetS) {
      this.listeProjet.find(item => {
        if (item.id == projetS) {
          this.listeInfoProjet = item;
        }
      });
    },
    onchangeCompte(selectPlan) {
      console.log("selectPlan", selectPlan.length);
      this.listPlanComptable.forEach(element => {});
      this.hideInterface = false;
    },
    imprimerModePlan(mode) {
      this.loading = true;
      this.dialogueImprimer = true;
      let url =
        this.domaine +
        "projet/" +
        this.selectProjet +
        "/chantier/" +
        this.selectChantier +
        "/travaux/" +
        (this.selectTravaux ? this.selectTravaux : null) +
        "/taches/" +
        (this.selectTaches ? this.selectTaches : null) +
        "/imprimer/plan/" +
        this.user.id +
        "/" +
        mode +
        "/annee/" +
        (this.selectAnnee ? this.selectAnnee : null);
      this.$http.get(url).then(response => {
        if (response.body) {
          this.loading = false;
          this.dialogueImprimer = false;
          window.open(url);
        }
      });
      this.dialogueImprimer = false;
    },
    initBarChart(row) {
      const barChart = echarts.init(this.$refs.bar_chart);
      const barChartOptions = {
        title: {
          text: "Statistiques des indicateurs clés des projets",
          left: "left",
          subtextStyle: {
            color: "#007BFF",
            fontSize: 14,
            cursor: "pointer",
            fontWeight: "bold"
          },
          // Activer les événements sur le sous-titre
          triggerEvent: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" }
        },
        legend: {
          data: [
            "Montant du marché",
            "Budget total",
            "Montant encaissé",
            "Montant décaissé"
          ],
          bottom: 0
        },
        xAxis: {
          type: "category",
          data: row.projects.map(project => project.substring(0, 5))
        },
        yAxis: {
          type: "value"
        },
        color: ["#5470C6", "#8e6e63", "#d3302f", "#378f3c"], // Palette de couleurs
        series: [
          {
            name: "Montant du marché",
            type: "bar",
            data: row.montantMarche,
            itemStyle: { color: "#5470C6" } // Couleur spécifique
          },
          {
            name: "Budget total",
            type: "bar",
            data: row.budgetTotal,
            itemStyle: { color: "#8e6e63" } // Couleur spécifique
          },
          {
            name: "Montant décaissé",
            type: "bar",
            data: row.montantDecaisse,
            itemStyle: { color: "#d3302f" } // Couleur spécifique
          },
          {
            name: "Montant encaissé",
            type: "bar",
            data: row.montantEncaisse,
            itemStyle: { color: "#378f3c" } // Couleur spécifique
          }
        ]
      };
      // Appliquer les options au graphique
      barChart.setOption(barChartOptions);
      const container = this.$refs.bar_chart;
      const voirPlusLink = document.createElement("div");
      voirPlusLink.innerHTML = "Voir plus";
      voirPlusLink.style.cssText = `
          color: #007BFF;
          font-size: 14px;
          cursor: pointer;
          font-weight: bold;
          position: absolute;
          left: 0;
          top: 25px;
        `;

      voirPlusLink.addEventListener("click", () => {
        this.handleVoirPlusClick("stat_projet");
      });

      container.appendChild(voirPlusLink);
    },
    initChart(row) {
      const chart = echarts.init(this.$refs.chart);

      const options = {
        title: {
          text: "Courbe d'évolution des marges et du taux d'évolution physique",
          left: "left",
          subtextStyle: {
            color: "#007BFF",
            fontSize: 14,
            cursor: "pointer",
            fontWeight: "bold"
          },
          triggerEvent: true
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          formatter: function(params) {
            let result = params[0].axisValueLabel + "<br/>";
            params.forEach(param => {
              // Formater selon le type de donnée
              const value =
                param.seriesName === "Taux physique"
                  ? param.value + "%"
                  : param.value.toLocaleString() + " XOF";
              result +=
                param.marker + param.seriesName + ": " + value + "<br/>";
            });
            return result;
          }
        },
        legend: {
          data: ["Marge", "Taux physique"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: row.projects.map(project => project.substring(0, 5))
          
        },
        yAxis: [
          {
            type: "value",
            name: "Marge (XOF)",
            position: "left",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#4CAF50"
              }
            },
            axisLabel: {
              formatter: "{value} XOF"
            }
          },
          {
            type: "value",
            name: "Taux physique (%)",
            position: "right",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#1976D2"
              }
            },
            axisLabel: {
              formatter: "{value} %"
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "Marge",
            type: "line",
            smooth: true,
            yAxisIndex: 0, // Utilise le premier axe Y
            data: row.marges,
            lineStyle: {
              color: "#4CAF50",
              width: 3
            },
            itemStyle: {
              color: "#4CAF50"
            },
            symbol: "circle",
            symbolSize: 8
          },
          {
            name: "Taux physique",
            type: "line",
            yAxisIndex: 1, // Utilise le second axe Y
            smooth: true,
            data: row.taux,
            lineStyle: {
              color: "#1976D2",
              width: 3
            },
            itemStyle: {
              color: "#1976D2"
            },
            symbol: "circle",
            symbolSize: 8
          }
        ]
      };

      // Appliquer les options au graphique
      chart.setOption(options);

      const container = this.$refs.chart;
      const voirPlusLink = document.createElement("div");
      voirPlusLink.innerHTML = "Voir plus";
      voirPlusLink.style.cssText = `
      color: #007BFF;
      font-size: 14px;
      cursor: pointer;
      font-weight: bold;
      position: absolute;
      left: 0;
      top: 25px;
    `;

      voirPlusLink.addEventListener("click", () => {
        this.handleVoirPlusClick("courbe_marge");
      });

      container.appendChild(voirPlusLink);
    },
    initLineChart(row) {
      const chart = echarts.init(this.$refs.trans);
      
      // Formatage des données pour une meilleure lisibilité
      const formatNumber = (value) => {   
        return value.toString();
      };

      const options = {
        title: {
          text: "Etat des transactions des projets (Débit / Crédit)",     
          left: "left",
          subtextStyle: {
            color: "#007BFF",
            fontSize: 14,
            cursor: "pointer",
            fontWeight: "bold",
            width: 200,
            overflow: 'break'
          },
          triggerEvent: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: 'cross'
          },
          formatter: function(params) {
            let result = params[0].axisValue + '<br/>';
            params.forEach(param => {
              result += param.marker + param.seriesName + ': ' + 
              new Intl.NumberFormat().format(formatNumber(param.value)) + ' XOF<br/>';
            });
            return result;
          }
        },
        legend: {
          data: ["Débit", "Crédit"],
          top: '50px'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //     dataZoom: {
        //       yAxisIndex: 'none'
        //     },
        //     restore: {}
        //   }
        // },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            start: 0,
            end: 100
          }
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: row.mois,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: [
          {
            type: "value",
            name: "Débit",
            position: 'left',
            axisLabel: {
              formatter: value =>   new Intl.NumberFormat().format( formatNumber(value) )+ ' XOF'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#ff4d4f'
              }
            }
          },
          {
            type: "value",
            name: "Crédit",
            position: 'right',
            axisLabel: {
              formatter: value =>    new Intl.NumberFormat().format( formatNumber(value) ) + ' XOF'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#52c41a'
              }
            }
          }
        ],
        series: [
          {
            name: "Débit",
            type: "line",
            data: row.debit, // Prend la première valeur de chaque tableau
            yAxisIndex: 0,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              color: '#ff4d4f',
              width: 3
            },
            itemStyle: {
              color: '#ff4d4f'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255,77,79,0.3)' },
                { offset: 1, color: 'rgba(255,77,79,0.1)' }
              ])
            }
          },
          {
            name: "Crédit",
            type: "line",
            data: row.credit,
            yAxisIndex: 1,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              color: '#52c41a',
              width: 3
            },
            itemStyle: {
              color: '#52c41a'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(82,196,26,0.3)' },
                { offset: 1, color: 'rgba(82,196,26,0.1)' }
              ])
            }
          }
        ]
      };

      // Appliquer les options au graphique
         chart.setOption(options);
        
        // Ajouter le lien "Voir plus"
        const container = this.$refs.trans;
        const voirPlusLink = document.createElement("div");
        voirPlusLink.innerHTML = "Voir plus";
        voirPlusLink.style.cssText = `
          color: #007BFF;
          font-size: 14px;
          cursor: pointer;
          font-weight: bold;
          position: absolute;
          left: 0;
          top: 25px;
        `;

        voirPlusLink.addEventListener("click", () => {
          this.handleVoirPlusClick("transactions");
        });

      container.appendChild(voirPlusLink);

      // Gestion du redimensionnement
      window.addEventListener('resize', () => {
        chart.resize();
      });
    },
    handleVoirPlusClick(item) {
      console.log("Voir plus cliqué");
      this.typeGraph = item;
      this.showModalgraphData = true;
    }
  },
  mounted() {
    this.loadProjet();
    this.loadPlanComptable();
    this.loadData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/projet/DashboardComparatif.vue